import { Link } from 'react-router-dom';
import { MapPin, Star, Truck, ShieldCheck, BadgeCheck } from 'lucide-react';

const categoryLabels = {
  kirana: 'Kirana', fancy: 'Fancy', vegetables: 'Vegetables',
  dairy: 'Dairy', bakery: 'Bakery', cloth: 'Cloth',
  hotels: 'Hotels & Food', jewellery: 'Jewellery', mobiles: 'Mobiles', books: 'Books', artifacts: 'Artifacts & Crafts',
  medical: 'Medical', electronics: 'Electronics', electrical: 'Electrical',
  other: 'Other',
};

const TIER_PILL = {
  gold:   { cls: 'bg-amber-100 text-amber-900 border-amber-300', label: 'Gold' },
  silver: { cls: 'bg-slate-100 text-slate-800 border-slate-300', label: 'Silver' },
  bronze: { cls: 'bg-orange-50 text-orange-900 border-orange-200', label: 'Bronze' },
  new:    { cls: 'bg-blue-50 text-blue-800 border-blue-200', label: 'New' },
};

export default function StoreCard({ store }) {
  const trust = store.trust || {};
  const tier = TIER_PILL[trust.tier] || TIER_PILL.new;
  return (
    <Link to={`/stores/${store.id}`} data-testid={`store-card-${store.id}`} className="card-soft block overflow-hidden group">
      <div className="relative h-44 overflow-hidden bg-muted">
        <img src={store.image_url} alt={store.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute top-3 left-3 pill !bg-white !py-1">{categoryLabels[store.category] || store.category}</span>
        {trust.verified && (
          <span data-testid={`verified-badge-${store.id}`} className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-[#1B5E20] text-white px-2.5 py-1 text-[10px] font-bold shadow-sm">
            <BadgeCheck className="w-3 h-3"/>Verified Dukandaar
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading font-bold text-lg leading-tight text-ink line-clamp-1">{store.name}</h3>
          <div className="flex items-center gap-1 text-xs text-ink/70 shrink-0">
            <Star className="w-3.5 h-3.5 fill-[#F1C40F] text-[#F1C40F]" />
            <span className="font-semibold">{store.rating?.toFixed?.(1) || '4.5'}</span>
          </div>
        </div>
        <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2">{store.description}</p>
        <div className="mt-3 flex items-center justify-between gap-2 text-xs text-ink/70 flex-wrap">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3"/>{store.village}</span>
            <span className="inline-flex items-center gap-1"><Truck className="w-3 h-3"/>₹{store.delivery_fee} delivery</span>
          </div>
          {typeof trust.score === 'number' && (
            <span data-testid={`trust-pill-${store.id}`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold ${tier.cls}`} title={`Trust score ${trust.score}/100 · ${tier.label}`}>
              <ShieldCheck className="w-3 h-3"/>{trust.score}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
